import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/pickup-displays', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const setting = data => {
  return httpClient
    .post('/api/pickup-displays/settings', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getStudent = data => {
  return httpClient
    .post('/api/pickup-displays/get-student-monitorings', data)
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response))
}

export const getPreData = (Options = {}) => {
  return httpClient
    .get('/api/pickup-displays/pre-data', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const acknowledge = data => {
  return httpClient
    .post('/api/pickup-displays/acknowledge', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const priorityCall = data => {
  return httpClient
    .post('/api/pickup-displays/priority-call', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const cancelPickup = serialCard => {
  return httpClient
    .get(`/api/pickup-displays/cancel-pickup/${serialCard}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  getPreData,
  setting,
  getStudent,
  acknowledge,
  priorityCall,
  cancelPickup
}
